import { ContainerDiv } from './Container.styled';

const Container = ({ children }) => {
  return <ContainerDiv>{children}</ContainerDiv>;
};

export default Container;
